import React, { useEffect, useState } from 'react';
import FeedBacks from '../../components/FeedBacks/FeedBacks';
import DialogChatModal from '../../components/Modal/DialogChatModal';
import ProfileModal from '../../components/Modal/ProfileModal';
import BroadCastModal from '../../components/Modal/BroadCastModal';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { getVacancySingle } from '../../redux/actions/dashborad/getVacancySingle';
import { useForm } from 'react-hook-form';
import { isBroadcastField } from '../Moderation/Moderation';
import { removeVacancy } from '../../redux/actions/dashborad/removeVacancy';
import { toast } from 'react-toastify';
import { resetDeleteVacancyList, resetDisableVacancyList, resetRemoveVacancy, resetSendToModeration } from '../../redux/slices/dashboard.slice';
import { deleteVacancyList } from '../../redux/actions/dashborad/deleteVacancyList';
import { disableVacancyList } from '../../redux/actions/dashborad/disableVacancyList';
import { getTariff } from '../../utils/getTariff';
import { sendToModeration } from '../../redux/actions/dashborad/sendToModeration';
import ChatModal from '../Chat/ChatModal';

function ActivationIndex(props) {
  const { id } = useParams();
  const {
    getVacancySingle: { data: getVacancySingleData, error: getVacancySingleError, loading: getVacancySingleLoading },
    deleteVacancyList: { data: deleteVacancyListData, error: deleteVacancyListError, loading: deleteVacancyListLoading },
    disableVacancyList: { data: disableVacancyListData, error: disableVacancyListError, loading: disableVacancyListLoading },
    sendToModeration: { data: sendToModerationData, error: sendToModerationError, loading: sendToModerationLoading },
    removeVacancy: { data: removeVacancyData, error: removeVacancyError, loading: removeVacancyLoading },
  } = useSelector((state) => state.dashboard);
  const [isRestore, setIsRestore] = useState(false);
  useEffect(() => {
    if (deleteVacancyListData && !isRestore) {
      toast.success('Вакансия удалена');
      dispatch(resetDeleteVacancyList());
      navigate('/vacancy');
    }
  }, [deleteVacancyListData]);

  const formBroadcast = useForm();

  useEffect(() => {
    if (getVacancySingleData) {
      Object.keys(getVacancySingleData)?.map((key) => {
        if (isBroadcastField(key)) {
          formBroadcast.setValue(key, getVacancySingleData[key]);
        }
      });
    }
  }, [getVacancySingleData]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getVacancySingle(id));
  }, []);

  let navigate = useNavigate();

  const [broadcastModalState, setBroadcastModalState] = useState(false);
  const [chatModalState, setChatModalState] = useState(false);
  const [profileModalState, setProfileModalState] = useState(false);

  const handleContractor = () => {
    localStorage.setItem('contractorTabState', 'all');
    navigate('/detail');
  };

  const handleBroadcastModal = () => {
    setBroadcastModalState(!broadcastModalState);
  };

  // const handleProfileModal = () => {
  //     setProfileModalState(true)
  // }

  const handleCancelProfileModal = () => {
    setProfileModalState(false);
  };

  const handleDataFromProfileModalButton = () => {
    setProfileModalState(false);
    setChatModalState(true);
  };

  const handleChatModal = () => {
    setChatModalState(true);
  };

  const handleDataFromChatModal = () => {
    setProfileModalState(true);
    setChatModalState(false);
  };

  const handleCancelChatModal = () => {
    setChatModalState(false);
  };

  useEffect(() => {
    if (disableVacancyListData && !isRestore) {
      toast.success('Вакансия успешно деактивирована', { theme: 'colored', autoClose: '3000' });

      navigate('/vacancy');
      dispatch(resetDisableVacancyList());
    }
  }, [disableVacancyListData]);

  useEffect(() => {
    if (sendToModerationData) {
      toast.success('Вакансия успешно отправлена на модерацию', { theme: 'colored', autoClose: '3000' });

      navigate('/vacancy');
      dispatch(resetSendToModeration());
    }
  }, [sendToModerationData]);

  const handleRestore = () => {
    Swal.fire({
      title: 'Вы хотите восстановить вакансию?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Отменить',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteVacancyList({
            is_active: true,
            vacancies: [id],
          }),
        );
      }
    });
  };

  const handlePermanentlyDelete = () => {
    Swal.fire({
      title: 'Удалить вакансии безвозвратно?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Отменить',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(removeVacancy([id]));
      }
    });
  };

  useEffect(() => {
    if (deleteVacancyListData && disableVacancyListData && isRestore) {
      toast.success('Вакансия успешно восстановлена', { theme: 'colored', autoClose: '3000' });
      navigate(getVacancySingleData?.is_hr ? '/vacancy' : '/vacancy');
      dispatch(resetDeleteVacancyList());
      dispatch(resetDisableVacancyList());
      setIsRestore(false);
    }
  }, [deleteVacancyListData, disableVacancyListData]);

  useEffect(() => {
    if (removeVacancyData) {
      toast.success('Вакансия удалена безвозвратно', { theme: 'colored', autoClose: '3000' });
      navigate(getVacancySingleData?.is_hr ? '/vacancy' : '/vacancy');
      dispatch(resetRemoveVacancy());
    }
  }, [removeVacancyData]);

  const handleSendModeration = () => {
    Swal.fire({
      title: 'Вы действительно хотите отправить данную вакансию на модерацию ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(sendToModeration(id));
      }
    });
  };

  const handleDeActive = () => {
    Swal.fire({
      title: 'Вы действительно хотите деактивировать данную вакансию?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsRestore(true);
        dispatch(disableVacancyList([id]));
        dispatch(
          deleteVacancyList({
            is_active: true,
            vacancies: [id],
          }),
        );
      }
    });
  };

  const handleDelete = () => {
    Swal.fire({
      title: 'Вы действительно хотите удалить данную вакансию?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteVacancyList({
            is_active: false,
            vacancies: [getVacancySingleData?.id],
          }),
        );
      }
    });
  };

  const headInfo = [getVacancySingleData?.employer?.name, getVacancySingleData?.employer?.inn ? `ИНН ${getVacancySingleData?.employer?.inn}` : '', getVacancySingleData?.employer?.phone, getVacancySingleData?.employer?.email]?.filter((item) => item).join(', ');

  return (
    <div className="w-full flex flex-1 mt-10 p-1">
      <section className="container relative flex flex-1 flex-col mx-auto max-w-[1163px]">
        <div className="vacancies-box flex flex-col zero:flex-row p-1 gap-7 w-full justify-center">
          <div className="flex justify-start first:w-[67%] w-full first:p-1 p-4 flex-col">
            <div className="vacancy-heading vacancy-heading-wrap flex flex-col">
              <h2 className="title text-3xl font-semibold">Вакансия “{getVacancySingleData?.name}”</h2>
              <div className="flex flex-col md:flex-row justify-between gap-3">
                <div className="flex gap-3">
                  <span className="vacancy__label text-gray-400 mt-2 cursor-pointer">{headInfo}</span>
                  <span
                    className="vacancy__label text-gray-400 mt-2 underline cursor-pointer"
                    onClick={() => {
                      navigate(`/user/${getVacancySingleData?.employer?.id}`);
                    }}>
                    {getVacancySingleData?.employer?.name}
                  </span>
                </div>
                <button type="button" className="block md:hidden text-center border rounded py-2 px-4  text-gray-400 border-gray-400 border-1 w-full md:w-auto bg-white transition ease-in-out duration-300">
                  {getTariff(getVacancySingleData?.tariff)}
                </button>
                {/* {props.role === 'admin' ? (
                  <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={handleChatModal}>
                    диалог
                  </button>
                ) : (
                  ''
                )} */}
              </div>
            </div>
            <div className="vacancy-wrap mt-4 border-1 rounded-md border-gray-200 shadow-md">
              <div className="vacancy-box shadow rounded">
                <div className="vacancy-box-item p-4 flex items-center border-b-1 border-gray-200">
                  <div className="vacancy-box-header flex flex-col gap-3 third:gap-0 third:flex-row third:justify-between third:items-center items-start w-full h-fit">
                    <div className="vacancy-box__text text-gray-900 text-xl">
                      <span>Адрес вакансии: </span>
                      {getVacancySingleData?.location?.address}
                    </div>

                    {getVacancySingleData?.is_broadcast && (
                      <div className="relative px-3 py-1.5 border rounded border-emerald-400 bg-emerald-400 text-white" role="alert">
                        {' '}
                        Транслирование
                      </div>
                    )}
                  </div>
                </div>
                <div className="vacancy-box-item p-4 flex items-center border-b-1 border-gray-200">
                  <div className="vacancy-box flex flex-wrap gap-4">
                    <div className="me-5 mb-2">
                      <div className="vacancy-box__desc text-lg text-gray-500">
                        <small>Оплата:</small>
                      </div>
                      <div className="vacancy-box__text text-gray-900">
                        {getVacancySingleData?.min_shift_cost} - {getVacancySingleData?.max_shift_cost} руб./смена
                      </div>
                    </div>
                    <div className="me-5 mb-2">
                      <div className="text-lg text-gray-500 vacancy-box__desc  ">
                        <small>Периодичность выплат:</small>
                      </div>
                      <div className="vacancy-box__text text-gray-900">1 раз в неделю</div>
                    </div>
                    <div>
                      <div className="text-lg text-gray-500 vacancy-box__desc  ">
                        <small>Длительность смены:</small>
                      </div>
                      <div className="vacancy-box__text text-gray-900">
                        {getVacancySingleData?.min_work_duration}-{getVacancySingleData?.max_work_duration} часов
                      </div>
                    </div>
                  </div>
                </div>
                <div className="vacancy-box-item p-4 flex items-center border-b-1 border-gray-200">
                  <div className="vacancy-box flex gap-4">
                    <div className="me-5 mb-2">
                      <div className="vasc text-lg text-gray-500">
                        <small>Пол:</small>
                      </div>
                      <div className="vacancy-box__text text-gray-900">{getVacancySingleData?.sex == null ? '-' : getVacancySingleData?.sex ? 'Женский' : 'Мужской'}</div>
                    </div>
                    <div>
                      <div className="vasc text-lg  text-gray-500">
                        <small>Возраст:</small>
                      </div>
                      <div className="vacancy-box__text text-gray-900">
                        {getVacancySingleData?.min_age}-{getVacancySingleData?.max_age} лет
                      </div>
                    </div>
                  </div>
                </div>
                <div className="vacancy-box-item p-4 flex flex-col items-start justify-center border-b-1 border-gray-200">
                  <div className="vasc text-lg text-gray-500 mb-1">
                    <small>Описание вакансии:</small>
                  </div>
                  <div className="vacancy-box__text text-gray-900">{getVacancySingleData?.description}</div>
                </div>
                <div className="vacancy-box-item p-4 flex flex-col items-start justify-center">
                  <div className="vasc text-lg text-gray-500 mb-1">
                    <small>Требование к соискателю:</small>
                  </div>
                  <div className="vacancy-box__text text-gray-900">{getVacancySingleData?.requirements}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex first:w-[33%] w-full flex-col px-4 first:px-0">
            <div className="flex flex-col md:flex-row justify-end gap-3">
              <button type="button" className="hidden md:block text-center border rounded py-2 px-4  text-gray-400 border-gray-400 border-1 w-full md:w-auto bg-white transition ease-in-out duration-300">
                {getTariff(getVacancySingleData?.tariff)}
              </button>
              {getVacancySingleData?.is_active && getVacancySingleData?.is_hr && (
                <ChatModal vacancyId={id} employerId={getVacancySingleData?.employer?.id} className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" textBtn="Диалог" />
                // <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-fit hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={handleChatModal}>
                //   Диалог
                // </button>
              )}

              {props.role === 'admin' && getVacancySingleData?.is_active ? (
                <button type="button" className=" text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full md:w-auto transition ease-in-out duration-300" onClick={handleBroadcastModal}>
                  Транслирование
                </button>
              ) : (
                ''
              )}
            </div>
            <div className="mt-7">
              <FeedBacks vacancyId={id} />
            </div>
          </div>
        </div>
        {props.role === 'admin' ? (
          <div className="flex flex-col md:flex-row p-5 mb-2 gap-3">
            {getVacancySingleData?.is_broadcast ? (
              <button type="button" className=" text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full md:w-fit transition ease-in-out duration-300" onClick={handleDeActive}>
                Деактивировать
              </button>
            ) : getVacancySingleData?.is_active ? (
              <button type="button" className=" text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov mr-2 w-full md:w-fit transition ease-in-out duration-300" onClick={handleSendModeration}>
                Отправить на модерацию
              </button>
            ) : (
              <></>
            )}
            {!getVacancySingleData?.is_active ? (
              <>
                <button onClick={handleDeActive} class="bg-button text-white py-2 px-4 rounded w-full md:w-auto">
                  Восстановить
                </button>
                <button onClick={handlePermanentlyDelete} class="bg-red-500 text-white py-2 px-4 rounded w-full md:w-auto ">
                  {' '}
                  Удалить безвозвратно
                </button>
              </>
            ) : (
              <>
                {' '}
                <Link to={`/edit/vacancy/${getVacancySingleData?.id}`}>
                  <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto bg-white transition ease-in-out duration-300">
                    Редактировать
                  </button>
                </Link>
                <button type="button" onClick={handleDelete} className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto bg-white transition ease-in-out duration-300">
                  Удалить
                </button>
              </>
            )}
          </div>
        ) : (
          ''
        )}
      </section>

      <BroadCastModal form={formBroadcast} open={broadcastModalState} buttonState={true} onClose={handleBroadcastModal} />

      <ProfileModal open={profileModalState} sendDataToParent={handleCancelProfileModal} sendDataToParentFromButton={handleDataFromProfileModalButton} />

      <DialogChatModal open={chatModalState} sendDataToParent={handleDataFromChatModal} onCancel={handleCancelChatModal} />
    </div>
  );
}

export default ActivationIndex;
